import { TFunction } from "i18next";

import { errors, TRANSLATION_KEY } from "../../constants";
import { decodeHtmlEntities } from "../../helpers/html-decode.helpers";
import { TTranslationParams } from "../../models";

const PERMISSION_MESSAGE_TRANSLATION_KEYS = new Set<string>([
  errors.common.missingPermissionForEntity,
  errors.ride.bulkRideSkippedNoPermission,
]);

export const processDynamicTranslationParams = (
  params: TTranslationParams,
  translateFunction: TFunction,
): Record<string, string | number> =>
  Object.entries(params).reduce(
    (acc, [key, value]) => {
      if (
        typeof value === "object" &&
        value !== null &&
        TRANSLATION_KEY in value
      ) {
        acc[key] = decodeHtmlEntities(translateFunction(value.translationKey));
      } else if (typeof value === "string") {
        acc[key] = decodeHtmlEntities(value);
      } else {
        acc[key] = value;
      }

      return acc;
    },
    {} as Record<string, string | number>,
  );

export const localizePermissionTranslationParams = (
  translationKey: string,
  params: TTranslationParams | Record<string, string | number> | undefined,
  translateFunction: TFunction,
): TTranslationParams | Record<string, string | number> | undefined => {
  if (!params || !PERMISSION_MESSAGE_TRANSLATION_KEYS.has(translationKey)) {
    return params;
  }

  const localized = { ...params };
  const { action, entity } = params;

  if (typeof action === "string") {
    localized.action = translateFunction(`errors.permissionAction.${action}`, {
      defaultValue: action,
    });
  }

  if (typeof entity === "string") {
    localized.entity = translateFunction(`errors.permissionEntity.${entity}`, {
      defaultValue: entity,
    });
  }

  return localized;
};
